<template>
  <div v-if="hasMultipleVariants" class="variants-meta">
    <Button
      v-if="hasVariantsOutOfStock"
      form="underline"
      theme="secondary"
      @click="handleStockNotificationClick"
    >
      {{ buttonText.outOfStock }}
    </Button>
    <IconButton
      class="size-guide-trigger"
      :icon="icons.sizeGuide"
      form="underline"
      theme="secondary"
      @click="setOpenSizeGuide(true)"
    >
      {{ buttonText.sizeGuide }}
    </IconButton>
  </div>
</template>

<script>
import IconButton from "@/components/IconButton.vue";
import Button from "@/components/ButtonV2.vue";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "VariantsMeta",
  components: {
    IconButton,
    Button,
  },
  props: {
    buttonText: {
      type: Object,
      default: () => ({
        outOfStock: "Size Not In Stock?",
        sizeGuide: "View size guide",
      }),
    },
    icons: {
      type: Object,
      default: () => ({
        sizeGuide: "ruler",
      }),
    },
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapGetters("product", ["variants"]),
    hasMultipleVariants() {
      return this.variants.length > 1;
    },
    hasVariantsOutOfStock() {
      return this.variants.some((variant) => !variant.availableForSale);
    },
  },
  methods: {
    ...mapActions("product", ["setOpenSizeGuide", "setSelectedVariant"]),
    ...mapActions("add-to-bag", ["openStockNotification"]),
    handleStockNotificationClick() {
      this.setSelectedVariant(null);
      this.openStockNotification({
        product: this.product,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.variants-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.variant {
  border: 1px solid $color-grey;
  padding-left: 0;
  padding-right: 0;

  &--disabled {
    background-color: $color-grey-light;
    border-color: $color-grey-light;
    color: $color-grey-dark;

    &:hover {
      background-color: $color-grey-light;
      border-color: $color-grey-light;
      color: $color-grey-dark;
    }
  }

  &--selected {
    border-color: $color-grey-dark;
  }
}

.size-guide-trigger {
  padding: 0;
}
</style>
